
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Package } from 'lucide-react';

const ProcurementNotFound: React.FC = () => {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center py-10">
        <Package className="h-12 w-12 text-muted-foreground mb-4" />
        <p className="text-lg font-medium">Procurement not found</p>
        <p className="text-muted-foreground">The procurement you're looking for doesn't exist.</p>
      </CardContent>
    </Card>
  );
};

export default ProcurementNotFound;
